import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FlameIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Juan',
  city: 'Valencia',
  time: '5 min'
}, {
  name: 'Andrea',
  city: 'Buenos Aires',
  time: '8 min'
}, {
  name: 'Miguel',
  city: 'Santiago',
  time: '12 min'
}, {
  name: 'Sofía',
  city: 'Bogotá',
  time: '15 min'
}, {
  name: 'Carlos',
  city: 'Madrid',
  time: '18 min'
}, {
  name: 'Daniela',
  city: 'Lima',
  time: '22 min'
}];
export function RecentPurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Show first notification after 6 seconds
    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 6000);
    return () => clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    // Auto-hide after 5 seconds, then show next after 12 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    const nextTimer = setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 15000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, index, dismissed]);
  const current = purchases[index];
  return <AnimatePresence data-id="element-182">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-183">
          <div className="bg-[#111111] border border-[#1e1e1e] rounded-lg px-4 py-3 shadow-2xl flex items-center gap-3" style={{
        boxShadow: '0 8px 32px rgba(0,0,0,0.6), 0 0 12px rgba(207,155,46,0.1)'
      }} data-id="element-184">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#CF9B2E]/20 flex items-center justify-center" data-id="element-185">
              <FlameIcon className="w-4 h-4 text-[#CF9B2E]" data-id="element-186" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-187">
              <p className="text-[#F5F0E8] text-sm font-semibold leading-tight" data-id="element-188">
                {current.name} de {current.city}
              </p>
              <p className="text-[#9A9080] text-xs leading-tight mt-0.5" data-id="element-189">
                adquirió su copia hace {current.time}
              </p>
            </div>
            <button onClick={() => setDismissed(true)} className="flex-shrink-0 text-[#4a4a4a] hover:text-[#9A9080] transition-colors" aria-label="Cerrar notificación" data-id="element-190">
              <XIcon className="w-3.5 h-3.5" data-id="element-191" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}